import { type FC, useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { SetNewPasswordForm } from '../../features/new-password';

interface Props {
  email: string | null;
  code: string | null;
}

/**
 * The `/new-password` recovery page — the target of password-recovery email links. Requires an `email`
 * + `code` pair in the URL; a direct visit or malformed link has neither and returns to login.
 */
export const NewPasswordView: FC<Props> = ({ email, code }) => {
  const navigate = useNavigate();

  const isValid = !!email && !!code;

  useEffect(() => {
    if (!isValid) {
      navigate({ to: '/login', replace: true });
    }
  }, [isValid, navigate]);

  if (!isValid) {
    return null;
  }

  return <SetNewPasswordForm email={email} code={code} />;
};
